export default function($form) {
    var $params = $form.getExtForm();
    if (!$form.isValid(true)) {
        return;
    }
    var p = {
        taskId: $params.taskId,
        appId: $params.appId,
        formId: $params.formId,

    };
    //事件参数p里面可以传上p.treeUrl=""或者p.treeData=[]来指定树显示的数据。
    if ($form.fireEvent("beforeFlowTransmit", p, fn) === false) return;
    fn();
    function fn() {
        PF.show("flowTransmit", p, function(res) {
            if ($params.comment) {
                res['$comment'] = $params.comment;
            }
            function doTransfer(params) {
                if($params.extParams && $params.extParams.fullAuthType){
                  params.fullAuthType = $params.extParams.fullAuthType;
                }
                PF.api.process.transfer($params.taskId, params).then(res => {
                    var data = res.result;
                    if (!data.success) { //提交意见检查
                        if (data.errorType === "comment") {
                            if (data.errorCode === 'comment_check_stop') {
                                PF.message('info', $lang('您还没有填写意见,请填写意见!'));
                                return;
                            } else if (data.errorCode === 'comment_check_remind') {
                                PF.confirm($lang('您还没有填写意见,您确认是要继续转办？'), $lang('提示'), { type: 'warning' }).then(() => {
                                    params['$directSave'] = true;
                                    doTransfer(params);
                                }).catch(() => {});
                                return;
                            }
                        } else {
                            var errorMsg = '';
                            if (data.errorMsg) {
                                errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
                            }
                            PF.message('info', '转办失败' + errorMsg + '!');
                            return;
                        }
                    } else {
                        if ($form.fireEvent("afterFlowTransmit", params,res) === false) return;
                        $params.formActionComplete(); //关闭窗口
                    }
                }).catch(() => {});
            }
            doTransfer(res);
        });
    }
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-transmit.js